<template>
  <div class="popup_in">
    <div class="popup">
      <img
        style="width:42px;margin-bottom:10px"
        src="/assets/img/svg/alert.svg"
      />
      <h2 class="title title--40">
        לתשומת ליבך, ישנם שינויים שלא נשמרו
        <br />
        המשך פעולה יגרום לביטול השינויים המבוקשים
      </h2>
      <div>האם להמשיך?</div>
      <div class="flex flex--content--center flex-buttons">
        <a class="bt_blue" @click.prevent="onClickConfirm(false)">לא, חזרה</a>
        <a class="bt_blue" @click.prevent="onClickConfirm(true)">הבנתי, כן</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    confirmFunc: {
      required: true,
      type: Function
    }
  },
  methods: {
    onClickConfirm(confirm) {
      this.confirmFunc(confirm);
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.flex-buttons {
  gap: 40px;
  margin-top: 20px;
}
</style>
